export let PRIVILEDGES = [

  //admin level
  // { role: 'ADMIN', name: 'Dashboard', routerLink: "/dashboard", icon: 'dashboard' },
  { role: 'ADMIN', name: 'Purchase Policy', routerLink: '/products', icon: 'purchasepolicy' },
  { role: 'ADMIN', name: 'Renew Policy', routerLink: '/renewpolicy', icon: 'renewpolicy' },
  { role: 'ADMIN', name: 'My Quotes', routerLink: '/quotes', icon: 'quote' },
  { role: 'ADMIN', name: 'My Policies', routerLink: '/mypolicies', icon: 'mypolicies' },
  { role: 'ADMIN', name: 'My Documents', routerLink: '/policydocuments', icon: 'icons8-print-100' },
  { role: 'ADMIN', name: 'Transactions', routerLink: '/transactions', icon: 'soldstickers' },
  { role: 'ADMIN', name: 'Client Management', routerLink: '/client-management', icon: 'clientmanagement' },
  { role: 'ADMIN', name: 'Bank Management', routerLink: '/bank-management', icon: 'bankmanagement' },
  { role: 'ADMIN', name: 'User Management', routerLink: '/user-management', icon: 'usermanagement' },
  { role: 'ADMIN', name: 'Motor Risk', routerLink: '/motor-risk', icon: 'motorrisk' },

  // { role: 'ADMIN', name: 'Report', routerLink: '/report', icon: 'quote' },

  //Agent level
  // { role: 'agent', name: 'Dashboard', routerLink: "/dashboard", icon: 'dashboard' },
  { role: 'AGENT', name: 'Purchase Policy', routerLink: '/products', icon: 'purchasepolicy' },
  { role: 'AGENT', name: 'Renew Policy', routerLink: '/renewpolicy', icon: 'renewpolicy' },
  { role: 'AGENT', name: 'My Quotes', routerLink: '/quotes', icon: 'quote' },
  { role: 'AGENT', name: 'My Policies', routerLink: '/mypolicies', icon: 'mypolicies' },
  { role: 'AGENT', name: 'My Documents', routerLink: '/policydocuments', icon: 'icons8-print-100' },
  { role: 'AGENT', name: 'Transactions', routerLink: '/transactions', icon: 'soldstickers' },
  // { role: 'AGENT', name: 'Bank Management', routerLink: '/bank-management', icon: 'bankmanagement' },
  // { role: 'AGENT', name: 'User Management', routerLink: '/user-management', icon: 'usermanagement' },
  { role: 'AGENT', name: 'Client Management', routerLink: '/client-management', icon: 'clientmanagement' },
  // { role: 'agent', name: 'Report', routerLink: '/report', icon: 'quote' },

  //client level
  { role: 'client', name: 'Client Info', routerLink: "/profile", icon: 'dashboard' },
  { role: 'client', name: 'Purchase Policy', routerLink: '/products', icon: 'purchasepolicy' },
  { role: 'client', name: 'Renew Policy', routerLink: '/renewpolicy', icon: 'renewpolicy' },
  { role: 'client', name: 'My Quotes', routerLink: '/quotes', icon: 'quote' },
  { role: 'client', name: 'My Policies', routerLink: '/mypolicies', icon: 'mypolicies' },
  { role: 'client', name: 'My Documents', routerLink: '/policydocuments', icon: 'icons8-print-100' },
  { role: 'client', name: 'Transactions', routerLink: '/transactions', icon: 'soldstickers' },
  // { role: 'client', name: 'Bank Management', routerLink: '/bank-management', icon: 'bankmanagement' },
  // { role: 'client', name: 'User Management', routerLink: '/user-management', icon: 'usermanagement' },
  // { role: 'client', name: 'Client Management', routerLink: '/client-management', icon: 'clientmanagement' },



  //Broker user level
  { role: 'broker-user', name: 'Dashboard', routerLink: "/dashboard", icon: 'dashboard' },
  { role: 'broker-user', name: 'Purchase Policy', routerLink: '/products', icon: 'purchasepolicy' },
  { role: 'broker-user', name: 'Renew Policy', routerLink: '/renewpolicy', icon: 'renewpolicy' },
  { role: 'broker-user', name: 'My Quotes', routerLink: '/quotes', icon: 'quote' },
  { role: 'broker-user', name: 'My Policies', routerLink: '/mypolicies', icon: 'mypolicies' },
  { role: 'broker-user', name: 'My Documents', routerLink: '/policydocuments', icon: 'icons8-print-100' },
  { role: 'broker-user', name: 'Transactions', routerLink: '/transactions', icon: 'soldstickers' },
  { role: 'broker-user', name: 'Bank Management', routerLink: '/bank-management', icon: 'bankmanagement' },
  { role: 'broker-user', name: 'User Management', routerLink: '/user-management', icon: 'usermanagement' },
  { role: 'broker-user', name: 'Client Management', routerLink: '/client-management', icon: 'clientmanagement' },
  // { role: 'broker-user', name: 'Report', routerLink: '/report', icon: 'quote' },

  
  //Broker admin level
  { role: 'broker-admin', name: 'Dashboard', routerLink: "/dashboard", icon: 'dashboard' },
  { role: 'broker-admin', name: 'My Quotes', routerLink: '/quotes', icon: 'quote' },
  { role: 'broker-admin', name: 'My Policies', routerLink: '/mypolicies', icon: 'mypolicies' },
  { role: 'broker-admin', name: 'My Documents', routerLink: '/policydocuments', icon: 'icons8-print-100' },
  { role: 'broker-admin', name: 'Transactions', routerLink: '/transactions', icon: 'soldstickers' },
  { role: 'broker-admin', name: 'Bank Management', routerLink: '/bank-management', icon: 'bankmanagement' },
  { role: 'broker-admin', name: 'User Management', routerLink: '/user-management', icon: 'usermanagement' },
  { role: 'broker-admin', name: 'Client Management', routerLink: '/client-management', icon: 'clientmanagement' },
  // { role: 'broker-admin', name: 'Report', routerLink: '/report', icon: 'quote' },




]

//for bottom notifications and messages
export let PRIVILEDGESNEW = [

  { role: 'client', name: 'Notifications', routerLink: "/notifications", icon: 'notification' },
  { role: 'agent', name: 'Notifications', routerLink: "/notifications", icon: 'notification' },
  { role: 'broker-user', name: 'Notifications', routerLink: "/notifications", icon: 'notification' },
  { role: 'broker-admin', name: 'Notifications', routerLink: "/notifications", icon: 'notification' },


]

